<template>
  <hm-content title="">
    <div class="add-goods-container">
      <hm-step
        :steps="steps"
        :scroll="true"
        :step="currentStep"
        @scroll="windowScroll"
      ></hm-step>
      <el-scrollbar :style="{ height: scrollHeight + 'px' }">
        <div class="pvw flex flex-warp">
          <div>
            <el-form
              style="flex:1;"
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="100px"
              class="product-ruleForm"
            >
              <div id="base">1.基本信息</div>
              <el-form-item label="活动标题" prop="gameName">
                <el-input
                  style="width: 400px"
                  size="small"
                  clearable
                  class="mr10 ipt"
                  v-model.trim="ruleForm.gameName"
                  placeholder="请输入活动标题"
                ></el-input>
              </el-form-item>
              <el-form-item label="活动时间段选择" prop="activityDate">
                <!--el-date-picker
                  :default-time="['00:00:00', '23:59:59']"
                  v-model="ruleForm.activityDate"
                  :picker-options="pickerOptions0"
                  type="datetimerange"
                  align="right"
                  start-placeholder="活动开始时间"
                  end-placeholder="活动结束时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  size="small"
                  class="mr10"
                ></el-date-picker -->
                <div>
                  开始时间：
                  <el-date-picker
                          disabled
                          v-model="ruleForm.activityDate[0]"
                          type="datetime"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          :default-time="['00:00:00', '23:59:59']"
                          placeholder="开始时间"
                          size="small"
                          class="mr10"
                  >
                  </el-date-picker>
                </div>
                <div>
                  结束时间：
                  <el-date-picker
                          size="small"
                          :editable="false"
                          v-model="ruleForm.activityDate[1]"
                          type="datetime"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          :default-time="'23:59:59'"
                          placeholder="结束时间"
                          :picker-options="pickerOptions0"
                  >
                  </el-date-picker>
                </div>
                <el-popover
                  placement="top-start"
                  title="提示"
                  width="200"
                  trigger="hover"
                >
                  <div v-html="ptTip"></div>
                  <i
                    slot="reference"
                    class="el-icon-question"
                    style="fontSize:20px"
                  ></i>
                </el-popover>
                <div class="form-item-tip">
                  拼团失败如果参团失败，系统会自动发起退款。由于支付系统账户是每日0点提现到银行卡，请尽量不要在0点时候结束活动，否则会导致余额不足无法退款
                </div>
              </el-form-item>
              <el-form-item label="活动分享文案" prop="gameShareContent">
                <el-input
                  :maxlength="30"
                  style="width: 400px"
                  size="small"
                  clearable
                  class="mr10 ipt"
                  v-model.trim="ruleForm.gameShareContent"
                  placeholder="请输入活动分享文案，30字以内"
                ></el-input>
              </el-form-item>
              <!-- <el-form-item label="背景音乐链接" prop="gameBgm">
              <el-input
                style="width: 400px"
                size="small"
                clearable
                class="mr10 ipt"
                v-model="ruleForm.gameBgm"
                placeholder="请输入音乐链接/音乐网络地址"
              ></el-input>
            </el-form-item> -->
              <el-form-item label="主图：" prop="mainImgUrl">
                <my-upload
                        field="file"
                        @crop-success="cropSuccess"
                        @crop-upload-success="cropUploadSuccess"
                        @crop-upload-fail="cropUploadFail"
                        v-model="show"
                        v-if="show"
                        noCircle
                        noSquare
                        :width="750"
                        :height="360"
                        :headers="{ 'X-Access-Token': $token }"
                        :params="{ fileDir: 'mallDecoration' }"
                        :url="$uploadUrl"
                        img-format="png"
                ></my-upload>
                <!-- <my-upload
                field="file"
                @crop-success="cropSuccess"
                @crop-upload-success="cropUploadSuccess"
                @crop-upload-fail="cropUploadFail"
                v-model="show"
                noCircle
                noSquare
                :params="{ fileDir: 'mallDecoration' }"
                :headers="{ 'X-Access-Token': $token }"
                :width="750"
                :height="1334"
                :url="$uploadUrl"
                img-format="png"
              ></my-upload> -->
                <el-button
                        type="primary"
                        size="small"
                        v-show="!listHeaderImgUrl"
                        @click="toggleShow"
                >上传</el-button
                >
                <span class="form-tip"
                >图片尺寸建议750x1334（最多上传一张）</span
                >
                <div class="priview" v-if="listHeaderImgUrl">
                  <img :src="listHeaderImgUrl" alt="主图" />
                  <div class="opreat-wrapper flex item-center flex-center">
                    <el-button type="text" @click="handleRemove"
                    >删除</el-button
                    >
                  </div>
                </div>
              </el-form-item>

              <el-form-item label="活动规则说明" prop="gameRuleRemark">
                <hm-rich-editor
                  v-model="ruleForm.gameRuleRemark"
                  :html="ruleForm.gameRuleRemark"
                />
              </el-form-item>

              <el-form-item label="虚拟参与人数" prop="visualJoinNum">
                <span>在实际参与人数基础上增加</span
                ><el-input
                  type="number"
                  maxlength="30"
                  @mousewheel.prevent.native
                  style="width: 100px"
                  size="small"
                  clearable
                  class="mr10 ipt"
                  v-model.trim="ruleForm.visualJoinNum"
                  placeholder="请输入数字"
                ></el-input
                >人
              </el-form-item>
              <div id="gameRule">{{ steps.length === 3 ? 2 : 2 }}活动规则</div>

              <el-form-item label="团类型" prop="groupTeamType">
                <el-radio-group v-model="storeGameTeamRule.groupTeamType" disabled>
                  <el-radio label="personNumTeam">人数团</el-radio>
                  <el-radio label="numberTeam">数量团</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item label="自动成团" prop="autoGroupMode">
                <el-switch
                  disabled
                  v-model="storeGameTeamRule.autoGroupMode"
                  active-text="开启"
                  inactive-text="关闭"
                  active-value="yes"
                  inactive-value="no"
                >
                </el-switch>
                <div class="form-item-tip">
                  开启后，人数未满的团在结束时，系统会自动凑满人数使其成团，不再触发自动退款（库存不足时例外），商家只需要对已付款参团的真实买家发货。
                  合理开启，可以提高成团率
                </div>
                <div class="form-item-tip">
                  注：关闭自动成团，活动结束后会将拼团失败金额自动退款；设置后不可修改
                </div>
              </el-form-item>

              <el-form-item label="是否显示拼团列表中" prop="listShowMode">
                <el-radio-group v-model="storeGameTeamRule.listShowMode" disabled>
                  <el-radio label="yes">显示</el-radio>
                  <el-radio label="no">不显示</el-radio>
                </el-radio-group>

                <div class="form-item-tip">
                  请通过我的活动提取活动二维码
                </div>
              </el-form-item>
              <!-- <el-form-item prop="leaderProfitMode" label="团长优惠">
              <el-switch
                :disabled="ruleForm.updateMode === 'no'"
                v-model="storeGameTeamRule.leaderProfitMode"
                active-text="开启"
                inactive-text="关闭"
                active-value="yes"
                inactive-value="no"
              >
              </el-switch>
              <div class="form-item-tip">
                开启团长优惠有助于提高开团率。注意自动成团的团长也能享受团长优惠，请谨慎设置；设置后不可修改
              </div>
            </el-form-item> -->
              <el-form-item
                label="每人限制购买活动数量"
                prop="eachPurchaseTotalMode"
              >
                <el-radio-group
                  disabled
                  v-model="storeGameTeamRule.eachPurchaseTotalMode"
                >
                  <el-radio label="no">不限制</el-radio>
                  <el-radio label="yes">限制</el-radio>
                </el-radio-group>

                <div class="form-item-tip">
                  限制购买本活动内的不同商品总数量，超出不可参与购买本活动内商品
                </div>
              </el-form-item>
              <el-form-item label="是否限制开团数量" prop="groupTeamMode">
                <el-radio-group
                  disabled
                  v-model="storeGameTeamRule.groupTeamMode"
                >
                  <el-radio label="no">不限制</el-radio>
                  <el-radio label="yes">限制</el-radio>
                  <el-input
                    disabled
                    clearable
                    style="width:120px"
                    @input="filterGt0OrFixed4('groupTeamLimit')"
                    v-model.trim="storeGameTeamRule.groupTeamLimit"
                    size="small"
                    placeholder="请输入限制数量"
                  ></el-input>
                </el-radio-group>

                <div class="form-item-tip">
                  不限制，则人人可以成为团长；若限制，当数量为1时，表示每个商品仅可以开一个团，此时可以做超级团，一人开团，全员参与拼团
                </div>
              </el-form-item>
              <el-form-item label="添加商品" prop="drawTypeList">
                <!-- <div class="flex batch flex-end mb10">
                  <div
                    class="pointer"
                    v-show="ruleForm.updateMode === 'yes'"
                  >
                    <span class="delete-icon hmicon icon-xitong"></span>
                    批量导入商品
                  </div>
                </div> -->
                <div
                  v-for="(item, i) in storeGameTeamGoods"
                  :key="i"
                  style="marginTop:10px;"
                >
                  <div class="table game-select">
                    <div class="table-header flex">
                      <div class="flex-1 text-center">商品货号</div>
                      <div class="flex-1 text-center">商品名称</div>
                      <div class="flex-1 text-center">商品规格</div>
                      <div class="flex-1 text-center" v-if="mode">单人限购</div>
                      <div class="flex-1 text-center">活动库存</div>
                      <div class="flex-1 text-center">剩余库存</div>
                      <div class="flex-1 text-center">零售价</div>
                      <!-- <div
                        class="flex-1 text-center"
                        v-show="ruleForm.updateMode === 'yes'"
                      >
                        操作
                      </div> -->
                    </div>
                    <div class="table-body">
                      <div class="flex table-row item-center">
                        <div class="flex-1 text-center">
                          {{ item.goodsSn }}
                          <!-- <el-input
                            disabled
                            @focus="inputChange"
                            style="width:120px"
                            v-model.trim="item.goodsSn"
                            size="small"
                            placeholder="请选择商品货号"
                          ></el-input> -->
                        </div>
                        <div class="flex-1 text-center">
                          {{ item.wxshopSpuName }}
                          <!-- <el-input
                            disabled
                            @focus="inputChange"
                            style="width:120px"
                            v-model.trim="item.wxshopSpuName"
                            size="small"
                            placeholder="请选择商品名称"
                          ></el-input> -->
                        </div>
                        <div class="flex-1 text-center">
                          {{ item.specIdGroupName }}
                        </div>
                        <div class="flex-1 text-center" v-if="mode">
                          {{ item.eachPurchaseLimit }}
                          <!-- <el-input
                            disabled
                            type="number"
                            maxlength="30"
                            @mousewheel.prevent.native
                            style="width:130px"
                            v-model.trim="item.eachPurchaseLimit"
                            @input="filterGt0OrFixed('eachPurchaseLimit', i)"
                            size="small"
                            clearable
                            placeholder="请输入数字"
                          ></el-input> -->
                        </div>
                        <div class="flex-1 text-center">
                          <el-input
                            disabled
                            type="number"
                            maxlength="30"
                            @mousewheel.prevent.native
                            style="width:130px"
                            v-model.trim="item.totalStockSum"
                            size="small"
                            @input="filterGt0OrFixed('totalStockSum', i)"
                            clearable
                            placeholder="请输入库存"
                          ></el-input>
                        </div>
                        <div class="flex-1 text-center">
                          <el-input
                                  type="number"
                                  maxlength="30"
                                  @mousewheel.prevent.native
                                  style="width:130px"
                                  v-model.trim="item.remainStockSum"
                                  size="small"
                                  @keyup.native="proving1($event)"
                                  @input="filterGt0OrFixed('remainStockSum', i)"
                                  clearable
                                  placeholder="请输入库存"
                          ></el-input>
                        </div>
                        <div class="flex-1 text-center">
                          {{ item.retailPrice }}
                          <!-- <el-input
                            disabled
                            type="number"
                            maxlength="30"
                            clearable
                            @mousewheel.prevent.native
                            style="width:130px"
                            v-model.trim="item.retailPrice"
                            @input="filterGt0OrFixed3('retailPrice', i)"
                            size="small"
                            placeholder="零售价"
                          ></el-input> -->
                        </div>

                        <!-- <div
                          class="flex-1"
                          v-show="ruleForm.updateMode === 'yes'"
                        >
                          <div
                            class="add-wrapper flex flex-center"
                            v-if="i === 0"
                          >
                            <span
                              class="hmicon icon-hao pointer"
                              @click="addChild(i)"
                            ></span>
                          </div>
                          <div class="minus-wrapper flex flex-center" v-else>
                            <span
                              class="hmicon icon-jianhao pointer"
                              @click="deleteChild(i)"
                            ></span>
                          </div>
                        </div> -->
                      </div>
                      <div
                        v-show="item.storeGameTeamGoodsPrice.length"
                        style="marginTop:2px;borderTop:1px solid #ddd"
                      >
                        <div class="table-header flex">
                          <div class="flex-1 text-center">
                            <span v-if="storeGameTeamRule.groupTeamType==='personNumTeam'">成团人数（含团长）</span>
                            <span v-if="storeGameTeamRule.groupTeamType==='numberTeam'">成团数量（含团长）</span>
                          </div>
                          <div class="flex-1 text-center" v-if="profitMode">
                            团长优惠价
                          </div>
                          <div class="flex-1 text-center" v-if="storeGameTeamRule.groupTeamType !== 'numberTeam'">起拼数</div>
                          <div class="flex-1 text-center">参团价</div>
                          <!-- <div
                            class="flex-1 text-center"
                            v-show="ruleForm.updateMode === 'yes'"
                          >
                            操作
                          </div> -->
                        </div>
                        <div class="table-body">
                          <div
                            class="flex table-row item-center"
                            v-for="(v, index) in item.storeGameTeamGoodsPrice"
                            :key="index"
                          >
                            <div class="flex-1 text-center">
                              {{ v.openteamNumber }}
                              <!-- <el-input
                                disabled
                                type="number"
                                maxlength="30"
                                @mousewheel.prevent.native
                                style="width:130px"
                                v-model.trim="v.openteamNumber"
                                size="small"
                                @input="
                                  filterGt0OrFixed1('openteamNumber', index, i)
                                "
                                clearable
                                placeholder="成团人数（含团长）"
                              ></el-input> -->
                            </div>
                            <div class="flex-1 text-center" v-if="profitMode">
                              {{ v.leaderProfitPrice }}

                              <!-- <el-input
                                disabled
                                type="number"
                                maxlength="30"
                                clearable
                                @mousewheel.prevent.native
                                style="width:130px"
                                v-model.trim="v.leaderProfitPrice"
                                @input="
                                  filterGt0OrFixed2(
                                    'leaderProfitPrice',
                                    index,
                                    i
                                  )
                                "
                                size="small"
                                placeholder="团长优惠价"
                              ></el-input> -->
                            </div>
                            <div class="flex-1 text-center" v-if="storeGameTeamRule.groupTeamType !== 'numberTeam'">
                              {{ v.openteamGoodsNumberLowerLimit }}

                              <!-- <el-input
                                disabled
                                type="number"
                                maxlength="30"
                                clearable
                                @mousewheel.prevent.native
                                style="width:130px"
                                v-model.trim="v.openteamGoodsNumberLowerLimit"
                                @input="
                                  filterGt0OrFixed1(
                                    'openteamGoodsNumberLowerLimit',
                                    index,
                                    i
                                  )
                                "
                                size="small"
                                placeholder="起拼数"
                              ></el-input> -->
                            </div>
                            <div class="flex-1 text-center">
                              {{ v.jointeamProfitPrice }}

                              <!-- <el-input
                                disabled
                                type="number"
                                maxlength="30"
                                clearable
                                @mousewheel.prevent.native
                                style="width:130px"
                                v-model.trim="v.jointeamProfitPrice"
                                @input="
                                  filterGt0OrFixed2(
                                    'jointeamProfitPrice',
                                    index,
                                    i
                                  )
                                "
                                size="small"
                                placeholder="参团价"
                              ></el-input> -->
                            </div>
                            <!-- <div
                              class="flex-1"
                              v-show="ruleForm.updateMode === 'yes'"
                            >
                              <div
                                class="add-wrapper flex flex-center"
                                v-if="index === 0"
                              >
                                <span
                                  class="hmicon icon-hao pointer"
                                  @click="addChilds(i)"
                                ></span>
                              </div>
                              <div
                                class="minus-wrapper flex flex-center"
                                v-else
                              >
                                <span
                                  class="hmicon icon-jianhao pointer"
                                  @click="deleteChilds(i, index)"
                                ></span>
                              </div>
                            </div> -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-form-item>

              <div id="gameAstrict">
                {{ steps.length === 3 ? 3 : 3 }}活动限制
              </div>
              <el-form-item label="配送方式限制" prop="expressModeGroups">
                <el-checkbox-group
                  v-model="ruleForm.expressModeGroups"
                >
                  <div>
                    <el-checkbox label="shop_extract" >门店自提</el-checkbox>
                    <el-select
                        class="ml10"
                        clearable
                        multiple
                        v-model="ruleForm.shopIds"
                        placeholder="请选择可销售门店"
                        size="small"
                        filterable
                        @change="getCheckedStore"
                        v-if="storeCode != '53010017032439' && storeCode != '42010216070190' "
                    >
                      <el-option
                          label="全部门店"
                          value="all"
                          :disabled="selectOther"
                      ></el-option>
                      <el-option
                          :disabled="selectAll"
                          :label="v.shopName"
                          :value="v.shopId"
                          v-for="(v, i) in microShopStoreList"
                          :key="i"
                      ></el-option>
                    </el-select>
                    <el-select
                        class="ml10"
                        clearable
                        multiple
                        v-model="ruleForm.shopIds"
                        placeholder="请选择可销售门店"
                        size="small"
                        filterable
                        @change="getCheckedStore"
                        v-if="storeCode === '53010017032439' || storeCode === '42010216070190' "
                    >
                      <el-option
                          label="全部门店"
                          value="all"
                          :disabled="selectOther"
                      ></el-option>
                      <el-option
                          :disabled="selectAll"
                          :label="v.shopName"
                          :value="v.shopId"
                          v-for="(v, i) in dkMicroShopStoreList"
                          :key="i"
                      ></el-option>
                    </el-select>
                  </div>
                  <div>
                    <el-checkbox label="express_delivery" >快递物流</el-checkbox>
                    <el-select
                      size="small"
                      v-model="ruleForm.expressId"
                      filterable
                      class="ml10"
                      clearable
                      placeholder="请选择运费模板"
                    >
                      <el-option
                        :label="v.expressName"
                        :value="v.expressId"
                        v-for="(v, i) in expressList"
                        :key="i"
                      ></el-option>
                    </el-select>
                  </div>
                </el-checkbox-group>
              </el-form-item>
              <div class="flex flex-center">
                <el-button
                        type="primary"
                        size="small"
                        @click="submitForm('ruleForm')"
                >确认</el-button
                >
                <el-button size="small" @click="$router.back(-1)"
                  >返回</el-button
                >
              </div>
            </el-form>
          </div>
          <div class="text-center flex-1">
            <el-button
              class="fixed-but"
              size="small"
              type="danger"
              round
              @click="minimum"
              v-if="isCollapse"
            >
              <span class="hmicon icon-shouji"></span>
              <span>{{ isCollapse ? "点击展开" : "点击隐藏" }}</span>
              <span class="hmicon icon-youshuangjiantou arrow"></span>
            </el-button>
            <el-button
              v-else
              class="fixed-but"
              size="small"
              type="primary"
              round
              @click="minimum"
            >
              <span class="hmicon icon-shouji"></span>
              <span>{{ isCollapse ? "点击展开" : "点击隐藏" }}</span>
              <span class="hmicon icon-youshuangjiantou arrow"></span>
            </el-button>
          </div>
          <div class="pvws" v-show="!isCollapse">
            <img
              style="width:100%"
              src="https://imgcdn.hemiao100.com/ThemePictures/tejiatuan.png"
              alt=""
            />
          </div>
        </div>
      </el-scrollbar>
      <hm-filter-micro-shop-goods
        type="microShop"
        :visible="dialogVisible"
        :radio="isRadio"
        @saveGoods="saveGoods"
        @setLink="setLink"
        @close="dialogVisible = false"
      ></hm-filter-micro-shop-goods>
    </div>
  </hm-content>
</template>

<script>
import HmStep from "@/components/HmStep";
import myUpload from "vue-image-crop-upload";
import HmRichEditor from "@/components/HmRichEditor";
import HmFilterMicroShopGoods from "@/components/HmFilterMicroShopGoods";
import HmCountdown from "@/components/HmCountdown";
import { mapGetters } from "vuex";
import {getLoginUser} from "@/utils/auth";

export default {
  components: {
    HmStep,
    myUpload,
    HmRichEditor,
    HmFilterMicroShopGoods,
    HmCountdown
  },
  data() {
    const expressModeGroupsStatus = (rule, val, callback) => {
      if (val.findIndex(v => v === "shop_extract") > -1) {
        if (!this.ruleForm.shopIds.length) {
          return callback(new Error("请选择可销售门店"));
        }
      }
      if (val.findIndex(v => v === "express_delivery") > -1) {
        if (!this.ruleForm.expressId) {
          return callback(new Error("请选择运费模板"));
        }
      }

      callback();
    };
    const actDate = function(storeGameTeamRule, val, callback) {
      // if (val > +this.ruleForm.actMemberUpperLimit) {
      //   return callback(new Error("已报名人数不能大于活动人数上限"));
      // }

      if (
        this.ruleForm.activityDate &&
        !this.ruleForm.activityDate.length > 0
      ) {
        return callback(new Error("请选择活动时间段"));
      }
      const endTime = new Date(val[0]);
      const nowTime = new Date();
      let leftTime = parseInt((endTime.getTime() - nowTime.getTime()) / 1000);
      if (leftTime < 0) {
        this.start = false;
      } else {
        this.start = true;
      }

      callback();
    }.bind(this);
    const patterndRemarkFunc = function(storeGameTeamRule, val, callback) {
      if (!this.ruleForm.gameRuleRemark) {
        return callback(new Error("请输入活动规则说明"));
      }
      callback();
    }.bind(this);
    // const patterndDrawTypeDateFunc = function(storeGameTeamRule, val, callback) {
    //   this.storeGameTeamRule.seckillRuleList.map(v => {
    //     if (v.activityDate && !v.activityDate.length > 0) {
    //       return callback(new Error("请选择秒杀场次时间段"));
    //     }
    //   });
    //   callback();
    // }.bind(this);
    const patterndMainImgUrlFunc = function(storeGameTeamRule, val, callback) {
      if (!this.listHeaderImgUrl) {
        return callback(new Error("请选择主图"));
      }
      callback();
    }.bind(this);
    const patterndDrawTypeFunc = function(storeGameTeamRule, val, callback) {
      if (this.screening) {
        callback();
      } else {
        return callback(new Error("请选择秒杀场次"));
      }
    }.bind(this);
    const patterndDrawTypeListFunc = function(
      storeGameTeamRule,
      val,
      callback
    ) {
      let flag = true;
      this.storeGameTeamGoods.map(v => {
        if (this.storeGameTeamRule.eachPurchaseTotalMode === "yes") {
          if (
            !v.goodsSn ||
            !v.eachPurchaseLimit ||
            !v.totalStockSum ||
            !v.retailPrice
          ) {
            flag = false;
          }
          v.storeGameTeamGoodsPrice.map(item => {
            if (this.storeGameTeamRule.leaderProfitMode === "yes") {
              if (
                !item.openteamNumber ||
                !item.leaderProfitPrice ||
                !item.jointeamProfitPrice
              ) {
                flag = false;
              } else {
                if (item.openteamNumber <= 1) {
                  return callback(new Error("成团人数需大于1"));
                }
              }
            } else if (this.storeGameTeamRule.leaderProfitMode === "no") {
              if (!item.openteamNumber || !item.jointeamProfitPrice) {
                flag = false;
              } else {
                if (item.openteamNumber <= 1) {
                  return callback(new Error("成团人数需大于1"));
                }
              }
            }
          });
        } else if (this.storeGameTeamRule.eachPurchaseTotalMode === "no") {
          if (!v.goodsSn || !v.totalStockSum || !v.retailPrice) {
            flag = false;
          }
          v.storeGameTeamGoodsPrice.map(item => {
            if (this.storeGameTeamRule.leaderProfitMode === "yes") {
              if (
                !item.openteamNumber ||
                !item.leaderProfitPrice ||
                !item.jointeamProfitPrice
              ) {
                flag = false;
              } else {
                if (item.openteamNumber <= 1) {
                  return callback(new Error("成团人数需大于1"));
                }
              }
            } else if (this.storeGameTeamRule.leaderProfitMode === "no") {
              if (!item.openteamNumber || !item.jointeamProfitPrice) {
                flag = false;
              } else {
                if (item.openteamNumber <= 1) {
                  return callback(new Error("成团人数需大于1"));
                }
              }
            }
          });
        }
      });

      if (flag) {
        callback();
      } else {
        return callback(new Error("请填写所有项"));
      }
    }.bind(this);
    return {
      storeCode: "",
      expressList: [],
      pickerOptions0: {
        disabledDate(time) {
          let curDate = new Date().getTime();
          // 这里算出一个月的毫秒数,这里使用30的平均值,实际中应根据具体的每个月有多少天计算
          let day = 365 * 24 * 3600 * 1000;
          let dateRegion = curDate + day;
          return (
            time.getTime() < Date.now() - 8.64e7 || time.getTime() > dateRegion
          );
        }
      },
      endTime: "2019-11-11 18:12:00",
      isRadio: false,
      listHeaderImgUrl:
        "https://imgcdn.hemiao100.com/hemiaoBase/mallDecoration/1567661861598-7820bd76-8017-4a13.png",
      storeId: "",
      currentStep: 1,
      scrollHeight: 0,
      show: false,
      dialogVisible: false,
      mode: true,
      profitMode: false,
      teamMode: "",
      steps: [
        {
          id: "base",
          name: "基本信息"
        },
        {
          id: "gameRule",
          name: "活动规则"
        },
        {
          id: "gameAstrict",
          name: "活动限制"
        }
      ],
      ruleForm: {
        activityDate: "",
        gameName: "",
        gameRuleRemark: "",
        gameShareContent: "",
        gameBgm: "",
        visualJoinNum: "0",
        expressModeGroups: [],
        shopIds: [],
        expressId: ""
      },
      screening: "1",
      storeGameTeamRule: {
        listShowMode: "yes",
        autoGroupMode: "no",
        leaderProfitMode: "no",
        eachPurchaseTotalMode: "no",
        groupTeamLimit: "",
        groupTeamMode: "no",
        groupTeamType: "personNumTeam"
      },
      storeGameTeamGoods: [
        {
          goodsSn: "",
          wxshopSpuName: "",
          eachPurchaseLimit: "",
          totalStockSum: "",
          retailPrice: "",
          storeGameTeamGoodsPrice: [
            {
              openteamNumber: "",
              leaderProfitPrice: "",
              jointeamProfitPrice: ""
            }
          ]
        }
      ],
      threshold: {
        expressModeGroup: []
      },
      rules: {
        visualJoinNum: [
          {
            pattern: /^[0-9]\d*$/,
            message: "请输入正整数",
            trigger: "blur"
          },
          {
            required: true,
            message: "请输入虚拟参与人数",
            trigger: "blur"
          }
        ],
        gameName: [
          {
            required: true,
            message: "请输入活动标题",
            trigger: "blur"
          },
          { min: 2, max: 30, message: "长度在 2 到 30 个字符", trigger: "blur" }
        ],
        gameShareContent: [
          {
            required: true,
            message: "请输入活动分享文案",
            trigger: "blur"
          }
        ],
        mainImgUrl: [
          {
            required: true,
            validator: patterndMainImgUrlFunc,
            trigger: "blur"
          }
        ],
        gameRuleRemark: [
          {
            required: true,
            validator: patterndRemarkFunc,
            trigger: "blur"
          }
        ],
        activityDate: [
          {
            required: true,
            message: "请选择活动时间",
            trigger: "blur"
          },
          {
            validator: actDate,
            trigger: "blur",
            required: true
          }
        ],
        // leaderProfitMode: {
        //   trigger: "blur",

        //   required: true
        // },
        screening: [
          {
            required: true,
            validator: patterndDrawTypeFunc,
            trigger: "blur"
          }
        ],
        drawTypeList: [
          {
            required: true,
            validator: patterndDrawTypeListFunc,
            trigger: "blur"
          }
        ],
        estimatedNum: [
          {
            required: true,
            message: "请填写预计参与次数",
            trigger: "blur"
          }
        ],
        expressModeGroups: [
          {
            required: true,
            message: "请选择配送方式限制"
          },
          {
            required: true,
            validator: expressModeGroupsStatus
          }
        ]
        // eachPurchaseTotalMode: [
        //   {
        //     required: true,
        //     message: "请选择每人限制购买活动数量",
        //     trigger: "blur"
        //   }
        // ],
        // groupTeamMode: [
        //   {
        //     required: true,
        //     message: "请选择是否限制开团数量",
        //     trigger: "blur"
        //   }
        // ]
      },

      options: [
        {
          value: "1",
          label: "1"
        }
      ],
      start: true,
      sole: Boolean,
      isCollapse: true,
      ptTip: ""
    };
  },
  computed: mapGetters(["microShopStoreList", "dkMicroShopStoreList"]),
  watch: {
    "storeGameTeamRule.eachPurchaseTotalMode": {
      handler(val) {
        if (val === "no") {
          this.mode = false;
        } else {
          this.mode = true;
        }
      },
      deep: true
    },
    "storeGameTeamRule.leaderProfitMode": {
      handler(val) {
        if (val === "no") {
          this.profitMode = false;
        } else {
          this.profitMode = true;
        }
      },
      deep: true
    },
    "storeGameTeamRule.groupTeamMode": {
      handler(val) {
        if (val === "no") {
          this.teamMode = true;
        } else {
          this.teamMode = false;
        }
      },
      deep: true
    }
  },
  created() {
    this.queryExpressList();
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
    window.addEventListener("resize", this.handleResize, true);
    const { storeCode } = getLoginUser();
    this.storeCode = storeCode;
    console.log("this.storeCode:",this.storeCode);
    if (storeCode === '42010216070190' || storeCode === '53010017032439') {
      this.$store.dispatch("queryDkMicroStoreList");
    } else {
      this.$store.dispatch("queryMicroStoreList");
    }
    this.calcHeight();
    this.queryPtTip();
    this.activityDetail();
  },
  destroyed: function() {
    window.removeEventListener("scroll", this.handleScroll); //  离开页面清除（移除）滚轮滚动事件
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    getCheckedStore(storeList) {
      this.selectOther = storeList.findIndex(o => o !== "all") > -1;
      this.selectAll = storeList.findIndex(o => o === "all") > -1;
      if (this.selectAll) {
        this.ruleForm.shopIds = ["all"];
      }
    },
    // 运费模板
    async queryExpressList() {
      const { result } = await this.$store.dispatch("storeExpressConfigList");
      this.expressList = [];
      if (result.defaultTemplate) {
        this.expressList.push(result.defaultTemplate);
      }
      this.expressList.push(...result.templateList);
    },
    async queryPtTip() {
      const { result } = await this.$store.dispatch("queryPtTip");
      this.ptTip = result;
    },
    activityDetail() {
      const { gameId } = this.$route.query;
      const params = {
        gameId
      };
      return this.$store.dispatch("detailsSpecialAct", params).then(res => {
        if (res.code === "0") {
          res.result.expressModeGroups = res.result.expressModeGroups || [];
          res.result.shopIds = res.result.shopIds || [];
          for (let key in res.result) {
            this.ruleForm[key] = res.result[key];
          }
          this.listHeaderImgUrl = res.result.gameBgp;

          this.ruleForm.activityDate = [
            res.result.gameStartTime,
            res.result.gameEndTime
          ];
          this.storeGameTeamGoods = res.result.storeGameTeamGoods;
          this.storeGameTeamRule = res.result.storeGameTeamRule;
          this.listHeaderImgUrl = res.result.gameBgp;
          // res.result.rule.seckillRuleList.forEach(v => {
          //   v.activityDate = [v.roundStartTime, v.roundEndTime];
          // });
          // this.rule = res.result.rule;

          this.threshold = res.result.threshold;
        }
      });
    },
    cropSuccess() {},
    cropUploadFail() {},
    cropUploadSuccess(jsonData) {
      if (this.show) {
        this.listHeaderImgUrl = jsonData.result;
      } else if (this.showDetail) {
        this.uploadedDetailList.push(jsonData.result);
      }
    },
    windowScroll(i) {
      this.$nextTick(() => {
        document.getElementById(this.steps[i].id).scrollIntoView();
        this.currentStep = i + 1;
      });
    },
    toggleShow() {
      this.show = !this.show;
    },
    handleResize() {
      this.calcHeight();
    },
    calcHeight() {
      setTimeout(() => {
        const headerHeight = document.querySelector(".navbar")
          ? document.querySelector(".navbar").getBoundingClientRect().y
          : 0;
        const tagHeight = document.querySelector(".tags-view-container")
          ? document
              .querySelector(".tags-view-container")
              .getBoundingClientRect().y
          : 0;
        const stepsHeight = document.querySelector(".step-wrapper")
          ? document.querySelector(".step-wrapper").getBoundingClientRect().y
          : 0;
        const footerHeight = document.querySelector(".el-footer")
          ? document.querySelector(".el-footer").getBoundingClientRect().height
          : 0;
        this.scrollHeight =
          window.innerHeight -
          headerHeight -
          tagHeight -
          stepsHeight -
          footerHeight -
          80;
      }, 0);
    },
    handleScroll(e) {
      this.steps.map((v, i) => {
        const ele = document.getElementById(v.id);
        if (ele) {
          const offsetTop = ele.offsetTop;
          if (e.target.scrollTop + 360 > offsetTop) {
            this.currentStep = i + 1;
          } else {
            this.currentStep = i - 1;
          }
        }
      });
    },
    addChilds(i) {
      this.storeGameTeamGoods[i].storeGameTeamGoodsPrice.push({
        openteamNumber: "",
        leaderProfitPrice: "",
        jointeamProfitPrice: ""
      });
    },
    deleteChilds(i, index) {
      this.storeGameTeamGoods[i].storeGameTeamGoodsPrice.splice(index, 1);
    },
    addChild() {
      this.storeGameTeamGoods.push({
        goodsSn: "",
        eachPurchaseLimit: "",
        totalStockSum: "",
        retailPrice: "",
        seckillPrice: "",
        storeGameTeamGoodsPrice: [
          {
            openteamNumber: "",
            leaderProfitPrice: "",
            jointeamProfitPrice: ""
          }
        ]
      });
    },
    deleteChild(index) {
      this.storeGameTeamGoods.splice(index, 1);
    },
    filterGt0OrFixed(prop, i) {
      this.storeGameTeamGoods[i][prop] = this.storeGameTeamGoods[i][
        prop
      ].replace(/^(0+)/, ""); //过滤0开头
      this.storeGameTeamGoods[i][prop] = this.storeGameTeamGoods[i][prop].replace(".", "").replace("-", "").replace("--", "")
      // this.storeGameTeamRule.storeGameTeamRule[i].prop = this.storeGameTeamRule.storeGameTeamRule[
      //   i
      // ][prop].replace(/[^\d]/g, ""); //仅保留数字
      this.storeGameTeamGoods[i][prop] = this.storeGameTeamGoods[i][
        prop
      ].replace(/\.{2,}/g, ""); //两个连续的"."仅保留第一个"."

      // //去除其他"."
      // this.storeGameTeamRule.storeGameTeamRule[i][prop] = this.storeGameTeamRule.storeGameTeamRule[
      //   i
      // ][prop].replace(/^(\d+)\.(\d\d).*$/, "$1.$2"); //限制只能输入两个小数
      // if (
      //   this.storeGameTeamRule.storeGameTeamRule[i][prop].indexOf(".") < 0 &&
      //   this.storeGameTeamRule.storeGameTeamRule[i][prop] != ""
      // ) {
      //   //首位是0的话去掉
      //   this.storeGameTeamRule.storeGameTeamRule[i][prop] = parseFloat(
      //     this.storeGameTeamRule.storeGameTeamRule[i][prop]
      //   );
      // }
    },
    filterGt0OrFixed4(prop) {
      this.storeGameTeamRule[prop] = this.storeGameTeamRule[prop].replace(
        /^(0+)/,
        ""
      ); //过滤0开头
      this.storeGameTeamRule[prop] = this.storeGameTeamRule[prop]
        .replace(".", "")
        .replace("-", "");
      this.storeGameTeamRule[prop] = this.storeGameTeamRule[prop].replace(
        /[^\d]/g,
        ""
      ); //仅保留数字
      this.storeGameTeamRule[prop] = this.storeGameTeamRule[prop].replace(
        /\.{2,}/g,
        ""
      ); //两个连续的"."仅保留第一个"."
    },
    filterGt0OrFixed1(prop, index, i) {
      this.storeGameTeamGoods[i].storeGameTeamGoodsPrice[index][
        prop
      ] = this.storeGameTeamGoods[i].storeGameTeamGoodsPrice[index][
        prop
      ].replace(/^(0+)/, ""); //过滤0开头
      this.storeGameTeamGoods[i].storeGameTeamGoodsPrice[index][
        prop
      ] = this.storeGameTeamGoods[i].storeGameTeamGoodsPrice[index][prop]
        .replace(".", "")
        .replace("-", "");
      // this.storeGameTeamRule.storeGameTeamRule[i].prop = this.storeGameTeamRule.storeGameTeamRule[
      //   i
      // ][prop].replace(/[^\d]/g, ""); //仅保留数字
      this.storeGameTeamGoods[i].storeGameTeamGoodsPrice[index][
        prop
      ] = this.storeGameTeamGoods[i].storeGameTeamGoodsPrice[index][
        prop
      ].replace(/\.{2,}/g, ""); //两个连续的"."仅保留第一个"."
    },
    filterGt0OrFixed2(prop, index, i) {
      // this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.storeGameTeamGoods[i].storeGameTeamGoodsPrice[index][
        prop
      ] = this.storeGameTeamGoods[i].storeGameTeamGoodsPrice[index][
        prop
      ].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.storeGameTeamGoods[i].storeGameTeamGoodsPrice[index][
        prop
      ] = this.storeGameTeamGoods[i].storeGameTeamGoodsPrice[index][
        prop
      ].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.storeGameTeamGoods[i].storeGameTeamGoodsPrice[index][
        prop
      ] = this.storeGameTeamGoods[i].storeGameTeamGoodsPrice[index][prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.storeGameTeamGoods[i].storeGameTeamGoodsPrice[index][
        prop
      ] = this.storeGameTeamGoods[i].storeGameTeamGoodsPrice[index][
        prop
      ].replace(/^(\d+)\.(\d\d).*$/, "$1.$2"); //限制只能输入两个小数
      if (
        this.storeGameTeamGoods[i].storeGameTeamGoodsPrice[index][prop].indexOf(
          "."
        ) < 0 &&
        this.storeGameTeamGoods[i].storeGameTeamGoodsPrice[index][prop] != ""
      ) {
        //首位是0的话去掉
        this.storeGameTeamGoods[i].storeGameTeamGoodsPrice[index][
          prop
        ] = parseFloat(
          this.storeGameTeamGoods[i].storeGameTeamGoodsPrice[index][prop]
        );
      }
    },
    filterGt0OrFixed3(prop, i) {
      // this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.storeGameTeamGoods[i][prop] = this.storeGameTeamGoods[i][
        prop
      ].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.storeGameTeamGoods[i][prop] = this.storeGameTeamGoods[i][
        prop
      ].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.storeGameTeamGoods[i][prop] = this.storeGameTeamGoods[i][prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.storeGameTeamGoods[i][prop] = this.storeGameTeamGoods[i][
        prop
      ].replace(/^(\d+)\.(\d\d).*$/, "$1.$2"); //限制只能输入两个小数
      if (
        this.storeGameTeamGoods[i][prop].indexOf(".") < 0 &&
        this.storeGameTeamGoods[i][prop] != ""
      ) {
        //首位是0的话去掉
        this.storeGameTeamGoods[i][prop] = parseFloat(
          this.storeGameTeamGoods[i][prop]
        );
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.ruleForm.gameStartTime =
            this.ruleForm.activityDate && this.ruleForm.activityDate.length > 0
              ? this.ruleForm.activityDate[0]
              : "";
          this.ruleForm.gameEndTime =
            this.ruleForm.activityDate && this.ruleForm.activityDate.length > 0
              ? this.ruleForm.activityDate[1]
              : "";

          // this.storeGameTeamRule.seckillRuleList.forEach((v, i) => {
          //   v.roundSeqNum = i + 1;
          //   v.roundStartTime =
          //     v.activityDate && v.activityDate.length > 0
          //       ? v.activityDate[0]
          //       : "";
          //   v.roundEndTime =
          //     v.activityDate && v.activityDate.length > 0
          //       ? v.activityDate[1]
          //       : "";
          // });
          this.ruleForm.gameBgp = this.listHeaderImgUrl;
          let params = this.ruleForm;
          params.gameType = "bargains_team";

          //   if (this.storeGameTeamRule.screening == "daily") {
          //     this.storeGameTeamRule.drawPrizeNum = this.storeGameTeamRule.drawPrizeNumDaily;
          //     this.storeGameTeamRule.eachWinningUpperLimit = this.storeGameTeamRule.eachWinningUpperLimitDaily;
          //   } else {
          //     this.storeGameTeamRule.drawPrizeNum = this.storeGameTeamRule.drawPrizeNumTotal;
          //     this.storeGameTeamRule.eachWinningUpperLimit = this.storeGameTeamRule.eachWinningUpperLimitTotal;
          //   }
          // params = Object.assign(params, this.storeGameTeamRule);

          params = Object.assign(params, {
            storeGameTeamRule: this.storeGameTeamRule,
            storeGameTeamGoods: this.storeGameTeamGoods,
            threshold: this.threshold,
            isLook:'yes'
          });

          this.$store.dispatch("editSpecialAct", params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.$router.back(-1);
            }
          });
        } else {
          return false;
        }
      });
    },
    handleRemove() {
      this.listHeaderImgUrl = "";
    },

    saveGoods(data) {
      if (data.length > 0) {
        this.dialogVisible = false;
        if (this.storeGameTeamGoods.length === 1) {
          this.storeGameTeamGoods = [];
        }
        if (this.sole) {
          this.storeGameTeamGoods.splice(this.storeGameTeamGoods.length - 1, 1);
        }
        data.map(v => {
          this.storeGameTeamGoods.push({
            wxshopSpuName: v.wxshopSpuName,
            goodsSn: v.goodsSn,
            eachPurchaseLimit: v.eachMemberPurchaseLimit,
            totalStockSum: v.stockNum,
            retailPrice: v.showPrice,
            seckillPrice: "",
            wxshopSkuId: v.wxshopSkuId,
            storeGameTeamGoodsPrice: [
              {
                openteamNumber: "",
                leaderProfitPrice: "",
                jointeamProfitPrice: ""
              }
            ]
          });
        });
      } else {
        this.$message({
          message: "请选择商品",
          type: "warning"
        });
      }
    },
    setLink() {
      // if (this.currentLinkIndex !== -1) {
      //   this.currentProp[this.currentLinkPropName][
      //     this.currentLinkIndex
      //   ].goodsInfo = row;
      //   this.currentProp[this.currentLinkPropName][
      //     this.currentLinkIndex
      //   ].hrefAddress = `/pages/product/product?wxshopSpuId=${row.wxshopSpuId}`;
      // } else {
      //   this.currentProp.goodsInfo = row;
      //   this.currentProp.hrefAddress = `/pages/product/product?wxshopSpuId=${row.wxshopSpuId}`;
      // }
      this.dialogVisible = false;
      this.isRadio = false;
    },
    batchSetting() {
      this.dialogVisible = true;
    },
    inputChange() {
      this.dialogVisible = true;
      this.sole = true;
    },
    minimum() {
      this.isCollapse = !this.isCollapse;
    },
    proving1(e){
      let keynum = window.event ? e.keyCode : e.which;   //获取键盘码
      let keychar = String.fromCharCode(keynum);  //获取键盘码对应的字符
      if (keynum ==189|| keynum==190||keynum == 109) {
        this.$message.warning('禁止输入小数以及负数')
        e.target.value = ' '
      }
    }
  }
};
</script>
<style lang="scss">
.game-select {
  .el-select {
    width: 140px !important;
    .el-input {
      width: 140px !important;
    }
  }
}
</style>
<style lang="scss" scoped>
.fixed-but {
  position: fixed;
  top: 150px;
  right: 20px;
}
.pvw {
  .pvws {
    border: 1px solid #d9d9d9;
    width: 350px;
    margin-right: 100px;
    position: relative;
    position: fixed;
    right: 0;
    .depict {
      margin: 10px;
      line-height: 12px;
    }
    .commodityImg {
      width: 150px;
      height: 150px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .actcontent {
      // width: 200px;
      height: 150px;
      margin-left: 20px;
      .activityTitle {
        font-size: 20px;
        font-weight: 700;
        margin-top: -2px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box; //作为弹性伸缩盒子模型显示。
        -webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
        -webkit-line-clamp: 2; //显示的行
      }
      .activityPrice {
        font-size: 24px;
        color: #ff563a;
        font-weight: 600;
      }
      .originalCost {
        text-decoration: line-through;
        color: #c0c0c0;
      }
    }

    .hr {
      height: 10px;
      background-color: #f7f7f7;
    }
    .pvwimg {
      width: 100%;
      height: 100%;
      // position: relative;
    }
    .describe {
      width: 100%;
      color: #ff5336;
      font-size: 17px;
      font-weight: 500;
      position: absolute;
      left: 50%;
      margin-left: -50%;
      top: 215px;
    }
  }
  #audio_btn {
    position: absolute;
    left: 10px;
    top: 70px;
    z-index: 999999;
    width: 45px;
    height: 45px;
    background-image: url("https://imgcdn.hemiao100.com/hemiaoBase/ico_music.png");
    background-size: contain;
    background-repeat: no-repeat;
  }
  // .rotate {
  //   -webkit-animation: rotating 1.2s linear infinite;
  //   -moz-animation: rotating 1.2s linear infinite;
  //   -o-animation: rotating 1.2s linear infinite;
  //   animation: rotating 1.2s linear infinite;
  // }
}
.table {
  border: 1px solid #ddd;
  .table-header {
    padding: 16px 0;
    background: #f7f7f7;
    font-size: 14px;
    font-weight: bold;
  }
  .table-row {
    padding: 5px 0;
    font-size: 14px;
  }
  .table-row:nth-child(even) {
    background: #f7f7f7;
  }
  .add-wrapper,
  .minus-wrapper {
    margin: 0 auto;
  }
}
.priview {
  position: relative;
  width: 400px;
  height: 200px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
</style>
